import { render } from "./ResetPassword.vue?vue&type=template&id=e8c178c8&scoped=true"
import script from "./ResetPassword.vue?vue&type=script&lang=js"
export * from "./ResetPassword.vue?vue&type=script&lang=js"

import "./reset-password.scss?vue&type=style&index=0&id=e8c178c8&lang=scss&scoped=true"

import exportComponent from "/var/webapps/orangehrm/app/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8c178c8"]])

export default __exports__